import { render, staticRenderFns } from "./growerstockerdetails.vue?vue&type=template&id=15318848&scoped=true"
import script from "./growerstockerdetails.vue?vue&type=script&lang=js"
export * from "./growerstockerdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15318848",
  null
  
)

export default component.exports